import React, {ReactNode, useState} from 'react';
import cn from 'classnames';
import IconButton from '@material-ui/core/IconButton';
import {ChevronUpIcon} from '@components/icon/ChevronUpIcon';
import './ExpandToggle.sass';

interface ExpandToggleProps {
  expanded: ReactNode;
  minimized: ReactNode;
  hideToggle?: boolean;
}

/**
 * Generic component that renders an expanded and hidden state
 */
export const ExpandToggle: React.FC<ExpandToggleProps> = props => {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className={cn('expand-toggle', {expanded, 'hide-toggle': props.hideToggle})}>
      <div className="content">{expanded ? props.expanded : props.minimized}</div>
      <div className="expand-toggle-control">
        <IconButton role="switch" aria-checked={expanded} onClick={() => setExpanded(!expanded)}>
          <ChevronUpIcon className={cn({expanded})} tooltip={expanded ? 'Collapse' : ''} />
        </IconButton>
        {expanded ? (
          <div className="expanded-line"></div>
        ) : (
          <div className="expand-text">Expand</div>
        )}
      </div>
    </div>
  );
};
